module.exports = __webpack_public_path__ + "media/images/dmc/member-03-d743557bd6004a42164523a0956e1488.jpg";